import Svg from "@src/components/svg/Svg";
import { SyntheticEvent, useRef } from "react";

interface Props {
  target: string;
  mainClass?: string;
}

const IconWithScroll = (props: Props) => {
  const handleClick = (event: SyntheticEvent) => {
    event.preventDefault();
  
    // @ts-ignore
    if(typeof scrollAnchor === 'undefined') {
      return;
    }

    // @ts-ignore
    scrollAnchor.scrollToSection(ref.current?.getAttribute('href'));
  }

  const ref = useRef<HTMLAnchorElement>(null);

  return (
    <a ref={ref} href={props.target} onClick={handleClick} className={`tfm-icon-with-scroll ${props.mainClass}`}>
      <Svg iconPath="#scroll-arrow" viewBoxWidth={20} viewBoxHeight={22} width={20} height={20}></Svg>
    </a>
  );
};

export default IconWithScroll;
